import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/store';
import User from '../user';

import Login from '../components/secondary/account/Login';
import Signup from '../components/secondary/account/signup/Signup';
import PasswordReset from '../components/secondary/account/PasswordReset';
import PasswordResetConfirm from '../components/secondary/account/PasswordResetConfirm';
import PasswordUpdate from '../components/secondary/account/PasswordUpdate';
import Profile from '../components/secondary/account/profile/Profile';
import WhiteLabelSetup from '../components/secondary/account/signup/setup/WhiteLabelSetup';
import AddMember from '../components/admin/AddMember';
import ManageMember from '../components/admin/ManageMember';
import Brooks1914Registration from '@/components/brooks_1914_registration/Brooks1914Registration';
import SauconyRegistration from '@/components/secondary/account/optin/vendors/SauconyRegistration';
import PerceptionPT from '@/components/secondary/account/optin/vendors/PerceptionPT';
import TrailRunnerMagazine from '@/components/secondary/account/optin/vendors/TrailRunnerMagazine';
import Layout from '@/components/secondary/account/Layout';
import UltraSignUp from '@/components/secondary/account/signup/vendors/UltraSignup';
import Whitelabel from '@/components/secondary/account/signup/Whitelabel';
import WhitelabelConnections from '@/components/secondary/account/profile/WhitelabelConnections';
import RedBull from '@/components/secondary/account/optin/vendors/RedBull';
import CustomOptin from '../components/secondary/account/optin/components/CustomOptin';
import { stepsEnum } from '../components/secondary/account/optin/components/steps';

// import AthleteDashboard from '../components/dashboard/AthleteDashboard';
// import Calendar from '../components/calendar/Calendar';
// import Training from '../components/training/Training';
// import TeamOverview from '../components/team_overview/TeamOverview';
// import PaymentDetails from '../components/secondary/account/PaymentDetails';
// import Archives from '../components/secondary/archives/Archives';
import Setup from '../components/secondary/account/signup/setup/Setup';
// import ContactUs from '../components/secondary/ContactUs';
// import Privacy from '../components/secondary/Privacy';
// import SuggestionBox from '../components/secondary/SuggestionBox';
// import Health from '../components/secondary/Health';
// import Survey from '../components/survey/Survey';
// import Onboarding from '../components/secondary/account/profile/onboarding/Onboarding';

const allowedLockoutRoutes = ['accounting', 'contact', 'privacy', 'suggestion', 'profile', 'setup', 'dashboard'];
export const exemptRoutes = ['teamOverview', 'profile'];
const currentAccessLevel = (route) => {
  const member = store.getters.loggedInMember;
  if (member.teams
      && member.teams.length > 0
      && !member.teams[0].athletesBilled) {
    return member.accessLevel;
  }
  if (member.memberType === 'Coach'
      && store.state.calendar.activeCalendar !== member.memberId
      && !exemptRoutes.includes(route)
      && !member.teams[0].trainerRetainsAccess) {
    return store.getters.rosterMember(store.state.calendar.activeCalendar).accessLevel;
  }
  return member.accessLevel;
};

Vue.use(Router);

const subdomain = (process.env.VUE_APP_PWR_ENV === 'production' || process.env.NODE_ENV === 'production') ? 'www' : 'staging2'
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/signup',
      component: Layout,
      children: [
        {
          path: '/',
          component: Signup,
          name: 'signup',
        },
        {
          path: 'ultrasignup',
          name: 'UltraSignUp',
          component: UltraSignUp,
          meta: {
            couponCode: 'usu_connectedtrail60',
          },
        },
        {
          path: 'team/:teamId',
          name: 'Team Signup',
          component: Signup,
        },
        {
          path: ':couponCode',
          name: 'Coupon Signup',
          component: Signup,
        },
      ],
    },
    {
      path: '/custom',
      component: Layout,
      children: [
        {
          path: 'setup',
          name: 'WhitelabelSetup',
          component: WhiteLabelSetup,
        },
        {
          path: 'rhf',
          component: Layout,
          children: [
            {
              path: '/',
              name: 'RunHappyFest',
              component: Whitelabel,
              meta: {
                name: 'Run Happy Fest',
                url: 'https://www.pwrlab.com',
                cohortId: 'eb5e3c7a-6ba1-4f00-97cb-572ad3e9ae37',
                couponCode: 'runhappyfest2021',
                permission: 3,
                permissions: false,
              },
            },
            {
              path: 'connections',
              name: 'RHFConnections',
              component: WhitelabelConnections,
              meta: {
                enabled: {
                  devices: {
                    garmin: true,
                    suunto: false,
                    suuntoV2: true,
                    polar: true,
                    coros: true,
                    apple: false,
                  },
                  sharing: false,
                  leaderboards: false,
                  permissions: false,
                },
              },
            },
          ],
        },
      ],
    },
    {
      path: '/register',
      name: 'Register',
      component: Layout,
      children: [
        {
          path: '7d0f446e-6fa7-49e1-8da3-1eb444ff4028',
          // path: '4edac5c9-1ac1-4d39-94d1-e43f29dcfe5f',
          name: 'DistributedEventTest',
          component: CustomOptin,
          meta: {
            isEvent: true,
            cohortId: '7d0f446e-6fa7-49e1-8da3-1eb444ff4028',
            cohortName: 'Soul Focus',
            customUrl: `https://${subdomain}.pwrlab.com/distributed-event/2022-runlocal/leaderboard`,
            config: {
              backgroundImage: 'https://s3.us-west-2.amazonaws.com/data.pwrlab.com/images/optin/7d0f446e-6fa7-49e1-8da3-1eb444ff4028/backgroundv2.jpg',
            },
            banner: {
              logo: 'https://s3.us-west-2.amazonaws.com/data.pwrlab.com/images/optin/7d0f446e-6fa7-49e1-8da3-1eb444ff4028/logo.png',
              title: '2022 Mileage & Personal Best Challenge',
            },
            steps: [stepsEnum.SOUL_FOCUS],
          },
        },
      ],
    },
    {
      path: '/optin',
      name: 'Optin',
      component: Layout,
      children: [
        {
          path: '2021-redbull-wfl',
          name: 'RedBull',
          component: RedBull,
          meta: {
            couponCode: '2021-redbull-wfl',
            teamId: 'ce171750-0f3f-4c0b-bea0-77e557c0b237',
            schemaId: 'ed13d92a-cc15-4e88-bb5c-d6234a1d3a3d',
          },
        },
        {
          path: 'saucony',
          name: 'sauconyRegistration',
          component: SauconyRegistration,
        },
        {
          path: 'dffd9490-6ec7-4dff-be65-95796c499d03',
          name: 'NAUCapstone',
          component: CustomOptin,
          meta: {
            cohortId: 'dffd9490-6ec7-4dff-be65-95796c499d03',
            cohortName: 'NAU Wellness Portal Participants',
            permission: 3,
            config: {
              backgroundColor: '#000',
              backgroundImage: 'https://s3.us-west-2.amazonaws.com/data.pwrlab.com/images/optin/dffd9490-6ec7-4dff-be65-95796c499d03/background.jpeg',
            },
            banner: {
              logo: 'https://s3.us-west-2.amazonaws.com/data.pwrlab.com/images/optin/dffd9490-6ec7-4dff-be65-95796c499d03/logo.gif',
              title: 'NAU Wellness Portal Participants',
              subtitle: 'Development & Testing next-gen training software made by NAU Computer Science students for their Senior year Capstone project.',
            },
            middle: {
              what: 'Link up and share activity data from your GPS devices to help the Capstone Team build the best product possible.',
              why: 'Your contribution allows the Capstone team to understand the data flow from smart watches and how to make that data meaningful for coaches.',
              how: 'Follow the registration steps below. Link your GPS device and continue recording your training.',
            },
            steps: [stepsEnum.TERMS_AND_CONDITIONS, stepsEnum.ACCOUNT],
          },
        },
        {
          path: 'aac36949-3e68-41c9-a37a-0ecfa4e26f5b',
          name: 'LX Innovation Program - Columbia',
          component: CustomOptin,
          meta: {
            cohortId: 'aac36949-3e68-41c9-a37a-0ecfa4e26f5b',
            cohortName: 'LX Innovation Program',
            permission: 3,
            config: {
              backgroundColor: '#2B7AB8',
              backgroundImage: 'https://s3.us-west-2.amazonaws.com/data.pwrlab.com/images/optin/aac36949-3e68-41c9-a37a-0ecfa4e26f5b/background.webp',
            },
            banner: {
              logo: 'https://s3.us-west-2.amazonaws.com/data.pwrlab.com/images/optin/aac36949-3e68-41c9-a37a-0ecfa4e26f5b/banner.png',
              title: 'Welcome to the Columbia LX Innovation Program',
              subtitle: 'Your Lived Experience is a critical part of our product development & testing process.',
            },
            middle: {
              what: 'Link up to share activity data from your GPS device and become part of our innovation program.',
              why: 'We’re working to understand YOUR needs. Real-world data & your input will accelerate and improve product development.',
              how: 'Follow the registration steps below. Link your GPS device and train normally. We\'ll keep you posted!',
            },
            steps: [stepsEnum.TERMS_AND_CONDITIONS, stepsEnum.ACCOUNT],
          },
        },
        {
          path: '4f5e65a9-b697-4f17-a182-0bb1b117880b',
          name: 'LX Innovation Program - The North Face',
          component: CustomOptin,
          meta: {
            cohortId: '4f5e65a9-b697-4f17-a182-0bb1b117880b',
            cohortName: 'LX Innovation Program',
            permission: 3,
            config: {
              backgroundColor: '#000',
              backgroundImage: 'https://s3.us-west-2.amazonaws.com/data.pwrlab.com/images/optin/4f5e65a9-b697-4f17-a182-0bb1b117880b/background.webp',
            },
            banner: {
              logo: 'https://s3.us-west-2.amazonaws.com/data.pwrlab.com/images/optin/4f5e65a9-b697-4f17-a182-0bb1b117880b/logo.png',
              title: 'Welcome to The North Face\'s LX Innovation Program',
              subtitle: 'Your Lived Experience is a critical part of our product development & testing process.',
            },
            middle: {
              what: 'Link up to share activity data from your GPS device and become part of our innovation program.',
              why: 'We’re working to understand YOUR needs. Real-world data & your input will accelerate and improve product development.',
              how: 'Follow the registration steps below. Link your GPS device and train normally. We\'ll keep you posted!',
            },
            steps: [stepsEnum.TERMS_AND_CONDITIONS, stepsEnum.ACCOUNT],
          },
        },
        {
          path: '3a4f4b7a-8b67-4f91-b4c3-4b2d04ccfa24',
          name: 'LX Innovation Program - Rei',
          component: CustomOptin,
          meta: {
            cohortId: '3a4f4b7a-8b67-4f91-b4c3-4b2d04ccfa24',
            cohortName: 'LX Innovation Program',
            permission: 3,
            config: {
              backgroundColor: '#000',
              backgroundImage: 'https://s3.us-west-2.amazonaws.com/data.pwrlab.com/images/optin/3a4f4b7a-8b67-4f91-b4c3-4b2d04ccfa24/background.jpeg',
            },
            banner: {
              logo: 'https://s3.us-west-2.amazonaws.com/data.pwrlab.com/images/optin/3a4f4b7a-8b67-4f91-b4c3-4b2d04ccfa24/logo.png',
              title: 'Welcome to REI\'s LX Innovation Program',
              subtitle: 'Your Lived Experience is a critical part of our product development & testing process.',
            },
            middle: {
              what: 'Link up to share activity data from your GPS device and become part of our innovation program.',
              why: 'We’re working to understand YOUR needs. Real-world data & your input will accelerate and improve product development.',
              how: 'Follow the registration steps below. Link your GPS device and train normally. We\'ll keep you posted!',
            },
            steps: [stepsEnum.TERMS_AND_CONDITIONS, stepsEnum.ACCOUNT],
          },
        },
        {
          path: '954016b0-0972-4c10-b05b-7432b5ed7c9d',
          name: 'SNB Ambassador Innovation Program',
          component: CustomOptin,
          meta: {
            cohortId: '954016b0-0972-4c10-b05b-7432b5ed7c9d',
            cohortName: 'SNB Ambassador Innovation Program',
            permission: 3,
            config: {
              backgroundColor: '#000',
              backgroundImage: 'https://s3.us-west-2.amazonaws.com/data.pwrlab.com/images/optin/954016b0-0972-4c10-b05b-7432b5ed7c9d/background.jpeg',
            },
            banner: {
              logo: 'https://s3.us-west-2.amazonaws.com/data.pwrlab.com/images/optin/954016b0-0972-4c10-b05b-7432b5ed7c9d/logo.png',
              title: 'Welcome to LX Data Sharing with Squirrel\'s Nut Butter',
              subtitle: 'Help us to understand your real-world Lived Experience and training needs.',
            },
            middle: {
              what: 'Your data says a lot about you! Link up and share activity data from your GPS devices.',
              why: 'Knowing more about what you do & how you do it will allow us to send relevant content your way.',
              how: 'Follow the registration steps below. Link your GPS device and continue recording your training.',
            },
            steps: [stepsEnum.TERMS_AND_CONDITIONS, stepsEnum.ACCOUNT],
          },
        },
        {
          path: 'b3068d32-bb98-42a4-9b75-a3a8c3a77596',
          name: 'PerceptionPT',
          component: PerceptionPT,
          meta: {
            cohortId: 'b3068d32-bb98-42a4-9b75-a3a8c3a77596',
            cohortName: 'Client Connection Portal',
            permission: 3,
          },
        },
        {
          path: '4fbe4430-1d57-452b-8901-13955106180b',
          name: 'TrailRunnerMagazine',
          component: TrailRunnerMagazine,
          meta: {
            cohortId: '4fbe4430-1d57-452b-8901-13955106180b',
            cohortName: 'Trail Runner Connectivity Program',
            permission: 3,
          },
        },
        {
          path: 'bf41ec4f-ebc0-4aa2-be97-632194cec1eb',
          name: 'LX Innovation Program',
          component: CustomOptin,
          meta: {
            cohortId: 'bf41ec4f-ebc0-4aa2-be97-632194cec1eb',
            cohortName: 'LX Innovation Program',
            permission: 3,
            config: {
              backgroundColor: '#E21935',
              backgroundImage: 'https://data.pwrlab.com/images/optin/bf41ec4f-ebc0-4aa2-be97-632194cec1eb/background.jpg',
            },
            banner: {
              logo: 'https://data.pwrlab.com/images/optin/bf41ec4f-ebc0-4aa2-be97-632194cec1eb/logo.png',
              title: 'Welcome to the New Balance LX Innovation Program',
              subtitle: 'Your Lived Experience is a critical part of our product development & testing process.',
            },
            middle: {
              what: 'Link up to share activity data from your GPS device and become part of our innovation program.',
              why: 'We’re working to understand YOUR needs. Real-world data & your input will accelerate and improve product development.',
              how: "Follow the registration steps below. Link your GPS device and train normally. We'll keep you posted!",
            },
            steps: [stepsEnum.TERMS_AND_CONDITIONS, stepsEnum.ACCOUNT],
          },
        },
        {
          path: '943c83ca-eda8-4be5-a6a9-d681fdc25289',
          name: 'Connected Training Log - Coach Krissy Moehl',
          component: CustomOptin,
          meta: {
            cohortId: '943c83ca-eda8-4be5-a6a9-d681fdc25289',
            cohortName: 'Connected Training Log',
            permission: 3,
            config: {
              backgroundColor: '#000',
              backgroundImage: 'https://data.pwrlab.com/images/optin/943c83ca-eda8-4be5-a6a9-d681fdc25289/background.jpg',
            },
            banner: {
              title: "Welcome to Coach Krissy's Data Sharing Program",
              subtitle: "Join for free today to take full advantage of Coach Krissy's online training.",
            },
            middle: {
              what: 'Link up to share activity data from your GPS device directly with Coach Krissy.',
              why: 'Using the PWR Lab platform ensures data accuracy and streamlines the coaching experience for both you and Coach Krissy.',
              how: "Follow the registration steps below. Link your GPS device and train normally. We'll keep you posted!",
            },
            steps: [stepsEnum.TERMS_AND_CONDITIONS, stepsEnum.ACCOUNT],
          },
        },
        {
          path: '1957cf8a-a4ec-4657-98f9-b46e23621897',
          name: 'M7 Ultra Trail Innovation',
          component: CustomOptin,
          meta: {
            cohortId: '1957cf8a-a4ec-4657-98f9-b46e23621897',
            cohortName: 'M7 Ultra Trail Innovation',
            permission: 3,
            config: {
              backgroundColor: '#000',
              backgroundImage: 'https://data.pwrlab.com/images/optin/1957cf8a-a4ec-4657-98f9-b46e23621897/background.jpeg',
            },
            banner: {
              logo: 'https://data.pwrlab.com/images/optin/1957cf8a-a4ec-4657-98f9-b46e23621897/logov3.png',
              height: '20%',
              width: '20%',
              title: 'Method Seven Ultra Trail Innovation Center',
              subtitle: 'Sign up today and help us understand how we can build the best trail running eyewear for YOU',
            },
            middle: {
              what: 'Team up with Method Seven by linking up and sharing your activity data.',
              why: 'We’re working to understand YOUR needs. Real-world data & your input will accelerate and improve product development.',
              how: 'Follow the registration steps below. Link your GPS device and run normally.',
            },
            steps: [stepsEnum.TERMS_AND_CONDITIONS, stepsEnum.ACCOUNT],
          },
        },
        {
          path: '4421cce1-380c-4fdb-9893-362c678b90b1',
          name: 'Connected Training Log - Coach TJ David',
          component: CustomOptin,
          meta: {
            cohortId: '4421cce1-380c-4fdb-9893-362c678b90b1',
            cohortName: 'Connected Training Log',
            permission: 3,
            config: {
              backgroundColor: '#000',
              backgroundImage: 'https://data.pwrlab.com/images/optin/4421cce1-380c-4fdb-9893-362c678b90b1/background.jpg',
            },
            banner: {
              logo: 'https://data.pwrlab.com/images/optin/4421cce1-380c-4fdb-9893-362c678b90b1/logov3.jpg',
              height: '20%',
              width: '20%',
              title: "Welcome to Microcosm's Data Sharing Program for Coach TJ",
              subtitle: "Join for free today to take full advantage of Microcosm's online training.",
            },
            middle: {
              what: 'Link up to share activity data from your GPS device directly with Coach TJ.',
              why: 'Using the PWR Lab platform ensures data accuracy and streamlines the coaching experience for both you and Coach TJ.',
              how: "Follow the registration steps below. Link your GPS device and train normally. We'll keep you posted!",
            },
            steps: [stepsEnum.TERMS_AND_CONDITIONS, stepsEnum.ACCOUNT],
          },
        },
      ],
    },
    {
      path: '/reset',
      name: 'passwordReset',
      component: PasswordReset,
    },
    {
      path: '/confirm/reset',
      name: 'passwordResetConfirm',
      component: PasswordResetConfirm,
    },
    {
      path: '/password',
      name: 'updatePassword',
      component: PasswordUpdate,
      meta: { requiresAuth: true },
    },
    // {
    //   path: '/onboarding',
    //   name: 'onboarding',
    //   component: Onboarding,
    //   meta: { requiresAuth: true },
    // },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter(to, from, next) {
        store.dispatch('signOut').catch(console.log);
        store.dispatch('clearAll');
        next({ name: 'login' });
      },
    },
    {
      path: '/2020-b1914',
      name: 'brooks1914Registration',
      component: Brooks1914Registration,
    },
    // {
    //   path: '/survey',
    //   name: 'survey',
    //   component: Survey,
    // },
    // {
    //   path: '/',
    //   name: 'dashboard',
    //   component: AthleteDashboard,
    //   meta: { requiresAuth: true },
    // },
    // {
    //   path: '/calendar',
    //   name: 'calendar',
    //   component: Calendar,
    //   meta: { requiresAuth: true },
    // },
    // {
    //   path: '/training',
    //   name: 'training',
    //   component: Training,
    //   meta: { requiresAuth: true },
    // },
    // {
    //   path: '/team',
    //   name: 'teamOverview',
    //   component: TeamOverview,
    //   meta: { requiresAuth: true },
    // },
    {
      path: '*',
      name: 'profile',
      component: Profile,
      meta: { requiresAuth: true },
    },
    {
      path: '/',
      name: 'dashboard',
      component: Profile,
      meta: { requiresAuth: true },
    },
    // {
    //   path: '/accounting',
    //   name: 'accounting',
    //   component: PaymentDetails,
    //   meta: { requiresAuth: true },
    // },
    // {
    //   path: '/archives',
    //   name: 'archives',
    //   component: Archives,
    //   meta: { requiresAuth: true },
    // },
    {
      path: '/setup',
      name: 'setup',
      component: Setup,
      props: true,
      meta: { requiresAuth: true },
    },
    // {
    //   path: '/contact',
    //   name: 'contact',
    //   component: ContactUs,
    //   meta: { requiresAuth: true },
    // },
    // {
    //   path: '/privacy',
    //   name: 'privacy',
    //   component: Privacy,
    //   meta: { requiresAuth: true },
    // },
    // {
    //   path: '/health',
    //   name: 'health',
    //   component: Health,
    //   meta: { requiresAuth: true },
    // },
    // {
    //   path: '/suggestion',
    //   name: 'suggestion',
    //   component: SuggestionBox,
    //   meta: { requiresAuth: true },
    // },
    {
      path: '/admin/member/add',
      name: 'Add Member',
      component: AddMember,
      meta: { requiresAuth: true },
    },
    {
      path: '/admin/member/manage',
      name: 'Manage Member',
      component: ManageMember,
      meta: { requiresAuth: true },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    // Globally, when moving to a different route, scroll to either a
    // previously saved scroll position (if history API is supported by browser)
    // or just to the top of the page.
    return savedPosition || { x: 0, y: 0 };
  },
});

function beforeEach(to, from, next) {
  let container;
  if (router.app && router.app.$container) {
    container = router.app.$container;
  } else {
    container = router.$container;
  }
  store.state.tmp.modalStack.forEach((id) => {
    container.eventBus.emit('closeModal', id);
  });
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const g = store.getters;
    const isAuthenticated = g.isAuthenticated();

    if (!isAuthenticated && g.isNative && g.hasRefreshTokens) {
      return store.dispatch('refreshToken').then(next);
    }

    if (isAuthenticated && (g.loggedInMember && g.loggedInMember.awsCognitoSub)) {
      if (g.loggedInMember.teams
        && g.loggedInMember.teams.length > 0
        && g.loggedInMember.memberType === 'Athlete'
        && g.loggedInMember.teams[0].athletes_can_view_dashboard === false
        && g.loggedInMember.accessLevel < User.ACCESS_ADMIN
        && ['setup', 'profile'].indexOf(to.name) === -1
      ) {
        return next({ name: 'profile' });
      }

      if (currentAccessLevel(to.name) < User.ACCESS_TRIAL
          && !allowedLockoutRoutes.includes(to.name)) {
        if (to.name === 'calendar' || to.name === 'training') {
          return next({
            name: 'accounting',
          });
        }
        return next({
          name: 'dashboard',
        });
      }
      return next();
    }

    return next({
      path: '/login',
      query: { redirect: to.fullPath },
    });
  }

  return next();
}

router.beforeEach((to, from, next) => beforeEach(to, from, next));

export default router;
